/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNodeNotarizationStatusIcon', [function () {
        return {
            scope: {
                notarization: '=accNodeNotarizationStatusIcon',
                isPreviousRevisionNotarization: '='
            },
            template: '<i ng-if="notarization" class="notarization-status-icon" ng-class="getIconClasses()"></i>' +
            '<i ng-if="notarization" class="notarization-status-icon notarization-status-icon--piece" ng-class="getIconClasses()"></i>',
            link: function ($scope) {
                $scope.getIconClasses = function () {
                    var
                        iconType = getIconType(),
                        revisionType = $scope.isPreviousRevisionNotarization ? 'previous-revision' : 'latest-revision',
                        processingStatus = getProcessingStatus();

                    return [
                        iconType,
                        revisionType,
                        processingStatus
                    ];
                };

                function isNotarizationSuccessful() {
                    return $scope.notarization['status'] === 'successful';
                }

                function getIconType() {
                    if ($scope.notarization['status'] === 'failed') {
                        return 'icon-acc-warning';
                    }

                    return isNotarizationSuccessful() && !$scope.isPreviousRevisionNotarization ? 'icon-acc-notarization_indicator_successful' : 'icon-acc-notarization_indicator';
                }

                function getProcessingStatus() {
                    if ($scope.notarization['status'] === 'failed') {
                        return 'failed'
                    }

                    return isNotarizationSuccessful() ? 'successful' : 'in-progress';
                }
            }
        }
    }]);
